module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/logout/logout.component.html
// module id = ./src/app/auth/logout/logout.component.html
// module chunks = main